import { useEffect } from "react";

// note E == 0

const DronePlayer = ({ note, keydown }) => {
  useEffect(() => {
    if (!keydown) return;

    const sampleUrl = "/samples/epad.mp3";
    const pitchRate = Math.pow(1.05946309436, note);
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    let active = true;
    let source = null;

    const request = new XMLHttpRequest();
    request.open("GET", sampleUrl, true);
    request.responseType = "arraybuffer";
    request.onload = () => {
      if (!active) return;
      audioContext.decodeAudioData(request.response)
        .then((buffer) => {
          // A key release, pitch change or unmount can precede decoding.
          if (!active) return;
          source = audioContext.createBufferSource();
          source.buffer = buffer;
          source.loop = true;
          source.connect(audioContext.destination);

          // start playing the sample
          source.playbackRate.value = pitchRate;
          source.start();
        })
        .catch((error) => {
          if (active) console.error("Unable to decode drone sample:", error);
        });
    };
    request.send();

    return () => {
      active = false;
      request.onload = null;
      request.abort();
      if (source) {
        source.stop();
        source.disconnect();
      }
      audioContext.close();
    };
  }, [note, keydown]);

  return null;
};

export default DronePlayer;
